import React from 'react';
import classnames from 'classnames';
import styles from './featuredDataProviders.module.scss';
import { Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import useQueryParams from 'v2/hooks/useQueryParams';
import { useHistory, useLocation } from 'react-router';
import Pagination from 'v2/common/Pagination/Pagination';
import restFactory from 'v2/utils/restFactory';
import useGetPageNumber from 'v2/hooks/useGetPageNumber';
import { DjangoListResponse, FeaturedDataProvider } from 'v2/models';
import SearchBar from 'v2/common/SearchBar/SearchBar';
import EmptyPlaceholder from 'v2/common/DRM/ListPages/EmptyPlaceholder';
import FeaturedDataProvidersList from './FeaturedDataProvidersList';

const FeaturedDataProvidersContainer = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const location = useLocation();
  const page = useGetPageNumber({
    onNotValidPageNumber: changePage,
  });

  const searchText = queryParams.get('search') || '';

  const {
    data: {
      results: featuredDataProviders,
      count: featuredDataProvidersCount = 0,
    } = {},
    isLoading,
  } = useQuery(
    [
      'fetching_featured_data_provider_data',
      location.pathname,
      location.search,
    ],
    async () => {
      return await restFactory.get<DjangoListResponse<FeaturedDataProvider>>(
        `/dj/api/v1/featured_data_provider/`,
        {
          page: page,
          search: searchText,
        }
      );
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  function changePage(page: number) {
    history.push({
      pathname: `/featured-data-providers/${page}`,
      search: location.search,
    });
    window.scrollTo(0, 0);
  }

  const handleSearch = (search: string) => {
    if (search.length === 0 || search.length > 2) {
      const params = new URLSearchParams({ search });
      history.push({
        pathname: '/featured-data-providers/1',
        search: params.toString(),
      });
    }
  };

  return (
    <div className={classnames('container-xl', styles.listContainer)}>
      <div
        className={classnames(
          'd-flex justify-content-between position-relative z-index-1',
          styles.titleBackground
        )}
        style={{ height: '122px' }}
      >
        <div className="container-xl d-flex justify-content-between position-relative fix-bg-images px-0">
          <div className="d-flex align-items-center text-truncate">
            <h1 className="m-0 text-truncate pr-1" role="heading">
              New Providers
            </h1>
          </div>
        </div>
      </div>
      <div className={classnames('container-xl', styles.filterRow)}>
        <div className={classnames(styles.filterContainer)}>
          <div className={classnames('d-flex align-items-center row p-0')}>
            <SearchBar
              placeHolder="Search"
              currentText={searchText || ''}
              onSearch={handleSearch}
              lengthTextValidation={{
                operator: '>',
                number: -1,
                debounce: 500,
              }}
            />
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="loadingIndicatorContainer" aria-label="loading-spinner">
          <Spinner animation="border" />
        </div>
      ) : !searchText || featuredDataProvidersCount ? (
        <>
          <FeaturedDataProvidersList list={featuredDataProviders} />
          <Pagination
            totalCountOfItems={featuredDataProvidersCount}
            callBack={changePage}
            currentPageOfItems={page}
          />
        </>
      ) : (
        <EmptyPlaceholder message="Try adjusting your search or filter to find what you’re looking for." />
      )}
    </div>
  );
};

export default FeaturedDataProvidersContainer;
